import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppointmentForm } from '../components/AppointmentForm';
import { appointmentService } from '../services/appointment';
import { CreateAppointmentData } from '../types/appointment';
import { toast } from '../utils/toast';

const CreateAppointment: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const patientId = searchParams.get('patientId') || '';

  const handleSubmit = async (data: CreateAppointmentData) => {
    try {
      setLoading(true);
      await appointmentService.createAppointment(data);
      toast.success('Appointment created successfully');
      navigate('/appointments');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to create appointment';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Create New Appointment</h1>
        <p className="mt-1 text-sm text-gray-600">
          Schedule a new patient appointment for recording and transcription
        </p>
      </div>

      <AppointmentForm
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        loading={loading}
        initialData={patientId ? { patientId } : undefined}
      />
    </div>
  );
};

export default CreateAppointment;
